import type { DiferenciaProrrateo } from "@/features/prorrateo/types";

/** Tolerancia (centavos) para considerar que dos importes coinciden. */
export const TOLERANCIA_PRORRATEO = 0.01;

/** Redondea a 2 decimales con la semántica bancaria de Math.round. */
export const round2 = (n: number): number => Math.round(n * 100) / 100;

/**
 * VO que la UI consume para pintar el banner de resumen. La regla de
 * "coincide" es la única lógica de negocio que vive en el frontend ·
 * el backend valida con la misma tolerancia.
 */
export function calcularDiferencia(
  suma: number,
  subtotal: number
): DiferenciaProrrateo {
  const monto = round2(suma - subtotal);
  return {
    suma,
    subtotal,
    monto,
    coincide: Math.abs(monto) <= TOLERANCIA_PRORRATEO,
  };
}
